import { Component } from '@angular/core';
import { OperationTableRowComponent } from '@components/operation-table-row/operation-table-row.component';

@Component({
    selector: 'app-operation-table-row-wrap',
    templateUrl: './operation-table-row-wrap.component.html',
    styleUrls: [
        './operation-table-row-wrap.component.scss',
        '../alarm-table-row-wrap/alarm-table-row-wrap.component.scss',
    ],
    standalone: false
})
export class OperationTableRowWrapComponent extends OperationTableRowComponent {}
